import { Hammer, Truck, Ruler } from 'lucide-react';

const services = [
  {
    icon: Ruler,
    title: 'Izrada namještaja',
    description: 'Kreiranje jedinstvenog namještaja prema vašim željama i prostornim mogućnostima. Svaki komad je pažljivo dizajniran i izrađen s preciznošću.',
  },
  {
    icon: Hammer,
    title: 'Montaža namještaja',
    description: 'Profesionalna montaža i instalacija s pažnjom prema svakom detalju. Naš tim osigurava da sve bude savršeno postavljeno.',
  },
  {
    icon: Truck,
    title: 'Prijevoz robe',
    description: 'Siguran i brz prijevoz vašeg namještaja direktno do vašeg doma. Brinemo se o sigurnosti vaših stvari od početka do kraja.',
  },
];

export function Services() {
  return (
    <section id="usluge" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl mb-6 text-gray-900">Naše usluge</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Pružamo cjelovita rješenja za vaš dom, od dizajna do isporuke
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-8 md:p-3 lg:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-16 h-16 bg-yellow-500 rounded-xl flex items-center justify-center mb-6">
                <service.icon className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl mb-4 text-gray-900">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
